module.exports = __webpack_public_path__ + "img/vod-icon-down.3cd481c7.svg";